import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { handleLogout } from "../../utils/helperFunctions";
import Navbar from "./Navbar";
import SideNav from "./SideNav";
import CustomModal from "./CustomModal";
import AppSwitchTransition from "./AppSwitch/AppSwitchTransition";
import useZustandStore from "../../zustandStore/useZustandStore";

const MainLayout = ({ children }) => {
  const [showFullSideNav, setShowFullSideNav] = useState(true);
  const currentUser = useZustandStore((val) => val?.currentUser);
  const { openLogoutConf, setOpenLogoutConf } = useZustandStore();
  const location = useLocation();
  const scrollRef = useRef(null);

  // Reset scroll on every route change. The app scrolls in the content div, not
  // the window, so nothing resets it on navigation — arriving at a detail page
  // from a scrolled list dropped you into the middle of it. React Router's
  // ScrollRestoration is not an option here: it requires a data router, and this
  // app uses the declarative <Routes> form.
  //
  // Keyed on pathname only, so mirroring filters into the query string (every
  // list page does this, with { replace: true }) does not yank the user back to
  // the top mid-scroll.
  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0, left: 0 });
  }, [location.pathname]);

  const isUserLoggedIn = !!currentUser?.roles;
  const displayNavAndSideNav =
    isUserLoggedIn &&
    location?.pathname !== "/login" &&
    location?.pathname !== "/404" &&
    location?.pathname !== "/pending-approval";

  return (
    <>
      <div className="flex h-screen flex-col">
        {displayNavAndSideNav && (
          <div className="w-full shrink-0">
            <Navbar />
          </div>
        )}

        <div className="flex min-h-0 flex-1">
          {displayNavAndSideNav && (
            <div
              className={`hidden shrink-0 transition-[width] duration-200 lg:block ${showFullSideNav ? "w-[240px] lg:w-[16%]" : "w-[72px] lg:w-[72px]"}`}
            >
              <div className="h-full">
                <SideNav
                  displayLogo={false}
                  showFullSideNav={showFullSideNav}
                  setShowFullSideNav={setShowFullSideNav}
                />
              </div>
            </div>
          )}

          <div
            id="HideScroll"
            ref={scrollRef}
            className={`w-full bg-primaryBG overflow-y-auto`}
          >
            {children}
          </div>
        </div>
      </div>

      {displayNavAndSideNav && <AppSwitchTransition />}

      {openLogoutConf && (
        <CustomModal
          title="Logout Seekho AMS"
          open={openLogoutConf}
          onClose={() => setOpenLogoutConf(false)}
          handleConfirmation={() => {
            handleLogout();
          }}
        >
          Are you sure you want to logout?
        </CustomModal>
      )}
    </>
  );
};

export default MainLayout;
